import { generateGUID } from "@faro-lotv/foundation";
import {
  createIElement,
  IElementRoomSection,
  IElementType,
  IElementTypeHint,
} from "@faro-lotv/ielement-types";
import { Vector3 } from "three";

/**
 * @returns an orphan IElementRoomSection as a temporary location marker
 * use position in world space as its pose to use in the edit-waypoints store.
 * @param point The position of the new location marker in world space
 */
export function createNewLocationMarker(point: Vector3): IElementRoomSection {
  return createIElement<IElementRoomSection>({
    type: IElementType.section,
    typeHint: IElementTypeHint.room,
    id: generateGUID(),
    name: "Location Marker",
    rootId: "",
    createdBy: "",
    pose: {
      pos: { x: point.x, y: point.y, z: point.z },
      gps: null,
      isWorldRot: false,
      scale: null,
      rot: null,
    },
  });
}
